import { useState, useCallback } from 'react';

export const useInlineEditableField = (
  initialValue: string,
  onSave: (value: string) => void
) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState('');

  const beginEdit = useCallback(() => {
    setDraft(initialValue);
    setIsEditing(true);
  }, [initialValue]);

  const updateDraft = useCallback((val: string) => {
    setDraft(val);
  }, []);

  const save = useCallback(() => {
    onSave(draft);
    setIsEditing(false);
  }, [draft, onSave]);

  const cancel = useCallback(() => {
    setIsEditing(false);
  }, []);

  return { isEditing, draft, beginEdit, updateDraft, save, cancel };
};
